import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@components/ui/accordion";
import { useGSAP } from "@gsap/react";
import { SanityDocument } from "@sanity/client";
import gsap from "gsap";
import { useRef } from "react";

interface FAQListProps {
  faqs: SanityDocument[];
}

export function FAQList({ faqs }: Readonly<FAQListProps>) {
  const faqListRef = useRef(null);

  useGSAP(
    () => {
      const items: HTMLElement[] = gsap.utils.toArray(".item");
      items.forEach((item) => {
        gsap.fromTo(
          `.item-${item.id}`,
          { autoAlpha: 0, x: 50 },
          {
            autoAlpha: 1,
            x: 0,
            duration: 0.5,
            scrollTrigger: {
              trigger: `.item-${item.id}`,
              start: "top bottom-=200",
              toggleActions: "play none none reverse",
            },
          },
        );
      });
    },
    { scope: faqListRef, dependencies: [faqs] },
  );

  if (faqs.length === 0) {
    return (
      <div className="py-8 text-center text-gray-500">
        No FAQs found matching your search
      </div>
    );
  }

  return (
    <Accordion
      ref={faqListRef}
      type="single"
      className="overflow-hidden"
      collapsible
    >
      {faqs?.map(({ question, answer, _id, slug }) => (
        <AccordionItem
          value={question}
          key={_id}
          id={slug.current}
          className={`item-${slug.current} item translate-x-[50] border-b`}
        >
          <AccordionTrigger className="px-5 text-start text-base md:text-lg">
            {question}
          </AccordionTrigger>
          <AccordionContent className="bg-white px-5 font-Satoshi-Variable text-base text-slate-600 md:text-lg">
            {answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
